<template>

    <div class="container">
      <H1 class="has-text-white is-size-3 top40">404 PAGE NOT FOUND</H1>
      <div class="has-text-light">The page you have requested does not exist. Please check the url and try again.</div>
      <div class="limitWidth">
        <hr/>
      </div>
    </div>

</template>

<script>


export default {
  components: {

  }
}
</script>
